import styled from '@emotion/styled'
import { Button } from '../../../atoms/button'
import { css } from '@emotion/react'

export const List = styled.ul`
  position: relative;
  padding-inline: 2.125rem;
  display: flex;
  flex-direction: row;
  gap: 3.125rem;

  list-style: none;

  & > li {
    & > button,
    & > a {
      height: 100%;

      position: relative;

      &[aria-expanded='true'] {
        & > * {
          --button-content-color: inherit !important;
        }
        &::after {
          content: '';

          position: absolute;
          left: 1.375rem;
          bottom: calc(-1.25rem);

          height: 1px;
          width: calc(100% - 2 * 1.375rem);

          background-color: var(--neutral-950);
        }
      }
    }
  }
`
export const ItemButton = styled(Button)<{ 'data-active'?: string; isSubdued?: boolean }>`
  --border-color: var(--neutral-950);

  text-transform: none;

  @media (min-width: 1280px) {
    /* only applied if one drop down is open */
    ${props =>
      props.isSubdued &&
      css`
        :not(:hover):not(:focus):not(:active)&[data-active='false'] {
          --button-content-color: var(--neutral-550);
          color: var(--button-content-color);
          --border-color: var(--button-content-color);
        }
      `}

    svg {
      path {
        stroke: var(--button-content-color);
      }
    }
  }
  &[data-active='true'] {
    & > p,
    & > span {
      font-weight: var(--medium);
    }
  }

  @media (min-width: 1280px) {
    width: 100%;
  }
`

export const PopoverContent = styled.ul`
  width: 100%;
  padding: 1.25rem 3.5rem 0.5rem;

  background-color: var(--dark-background-color);

  list-style: none;

  & > li:last-child > a {
    border-bottom: none;
  }
`

export const PopoverItemButton = styled(ItemButton)`
  padding: 1.625rem 0;
  width: calc(100% - 2rem);
  justify-content: space-between;
  border-bottom: solid var(--neutral-550) 1px;
  margin-inline: 1rem;

  &[data-active='true'],
  :active,
  :focus {
    & > p,
    & > span {
      font-weight: var(--medium);
    }
  }

  @media (min-width: 1279px) {
    &:hover {
      & > p {
        font-weight: var(--medium);
      }
    }
    
    --border-color: var(--border-color);
    margin-inline: 0;
    width: 100%;
    justify-content: start;
  }
`
